import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Card } from "../ui/card";
import { TransactionRow } from "./TransactionRow";
import { useOwnerData } from "@/hooks/useOwnerData";

export interface TransactionGroupProps {
  date: string;
  transactions: any[];
  transactionType?: string;
}

export const TransactionGroup = ({ date, transactions, transactionType }: TransactionGroupProps) => {
  const { data: ownerData } = useOwnerData();
  const isCommerceOrHardware = ownerData?.business_types?.name === "Commerce" || 
                              ownerData?.business_types?.name === "Quincaillerie";

  return (
    <div className="mb-4 md:mb-8 animate-fade-in">
      <h3 className="text-sm md:text-base font-medium text-gray-500 mb-2 md:mb-4">
        {date}
      </h3>
      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-full table-auto">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 md:px-6 py-2 md:py-3 text-left text-xs md:text-sm font-medium text-gray-500">
                  Heure
                </th>
                <th className="px-3 md:px-6 py-2 md:py-3 text-left text-xs md:text-sm font-medium text-gray-500">
                  Montant
                </th>
                <th className="px-3 md:px-6 py-2 md:py-3 text-left text-xs md:text-sm font-medium text-gray-500">
                  Quantité
                </th>
                <th className="px-3 md:px-6 py-2 md:py-3 text-left text-xs md:text-sm font-medium text-gray-500">
                  Race
                </th>
                <th className="px-3 md:px-6 py-2 md:py-3 text-left text-xs md:text-sm font-medium text-gray-500">
                  Nom
                </th>
                <th className="px-3 md:px-6 py-2 md:py-3 text-left text-xs md:text-sm font-medium text-gray-500">
                  Signature
                </th>
                {!isCommerceOrHardware && (
                  <th className="px-3 md:px-6 py-2 md:py-3 text-right text-xs md:text-sm font-medium text-gray-500">
                    Actions
                  </th>
                )}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {transactions.map((transaction: any) => (
                <TransactionRow
                  key={transaction.id}
                  transaction={transaction}
                  showType={false}
                />
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};